var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tariff && _vm.tariff.title) ? _c('v-separator') : _vm._e(), _vm._v(" "), (_vm.tariff && _vm.tariff.title) ? _c('v-expansion', [_c('div', {
    slot: "title"
  }, [_c('div', [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("\n                    Тариф: "), _c('strong', [_vm._v(_vm._s(_vm.tariff.title))])])], 1), _vm._v(" "), (_vm.tariff.daysLeft <= 30) ? _c('v-text', {
    attrs: {
      "error": ""
    }
  }, [_vm._v("\n                Осталось\n                " + _vm._s(_vm.tariff.daysLeft) + "\n                " + _vm._s(_vm.declOfNum(_vm.tariff.daysLeft, ['день', 'дня', 'дней'])) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('v-text', [_vm._v("\n            Включено с " + _vm._s(_vm.moment(_vm.tariff.startDate).format('DD.MM.YYYY'))), _c('br'), _vm._v("\n            Осталось " + _vm._s(_vm.tariff.daysLeft) + "\n            " + _vm._s(_vm.declOfNum(_vm.tariff.daysLeft, ['день', 'дня', 'дней'])) + "\n        ")]), _vm._v(" "), _c('v-text', {
    attrs: {
      "type": "caption"
    },
    slot: "caption"
  }, [_vm._v("\n            Подробнее\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-separator')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04397fea","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestProducts/TariffDetails.vue
// module id = 1064
// module chunks = 0